import { css } from '@emotion/css';

export const centeredButton = css`
  display: flex;
  justify-content: center;
  margin: 10px 0;
  width: 100%;
`;
